export { use100vh } from './src/use100vh'
export { AwaitStatus, AwaitStatus as Status, useAwait } from './src/useAwait'
export { useBeforeUnload } from './src/useBeforeUnload'
export { useClientSide } from './src/useClientSide'
export { useDebouncedState } from './src/useDebouncedState'
export { useDebouncedEffect } from './src/useDebouncedEffect'
export {
  useDispatchAtom,
  useAtomWithReducer,
  getDispatch,
  type Dispatch,
  type PromiseAction,
  type ThunkAction,
} from './src/useAtomWithReducer'
export {
  useDramaticallyInefficientMediaQuery,
  matchQuery,
  useDramaticallyInefficientMatchMediaQuery,
  useDramaticallyInefficientScrollListener,
} from './src/useDramaticallyInefficientMediaQuery'
export { useDramaticallyInefficientLocation } from './src/useDramaticallyInefficientLocation'
export { useEventListener } from './src/useEventListener'
export { useHappening } from './src/useHappening'
export { useInterval } from './src/useInterval'
export { useIsIntersecting } from './src/useIsIntersecting'
export { useLazyInitialLoad } from './src/useLazyInitialLoad'
export { useLinkClickHandler, makeLinkClickHandler } from './src/useLinkClickHandler'
export { useModal, useModalParams, useModalOpen, useSetModal, useModalInitialValue } from './src/useModal'
export { useNextRouter, type NextRouter } from './src/useNextRouter'
export { usePoll } from './src/usePoll'
export { usePrevious } from './src/usePrevious'
export { useQuery, type Response, QueryStatus, data, assertData, type QueryHelper } from './src/useQuery'
export { useQueryParams, useQueryParamsForNext } from './src/useQueryParams'
export { useRandom } from './src/useRandom'
export { useScrollRestoration } from './src/useScrollRestoration'
export { useScrollToFirstError, useScrollToFirstErrorFunction } from './src/useScrollToFirstError'
export { useSharedQuery, useFetchOnMount, type SharedQueryHelper, type Cache } from './src/useSharedQuery'
export { useSocialShare } from './src/useSocialShare'
export { useSocket, EventType as SocketEventType, type SocketReturn } from './src/useSocket'
export { useTimeout } from './src/useTimeout'
export { useUserConfig } from './src/useUserConfig'
export { usePersistentQueryData } from './src/usePersistentQueryData'
export { useDateCountdown } from './src/useDateCountdown'

export type { Event as SocketEvent } from './src/useSocket'
